/** time.js
 * 時間操作用のクラスモジュール
 * 分単位で管理するために
 */
export default class {
  /** コンストラクタ
   * @arg {String} time - hh:mm(:ss) 形式の時間を表す文字列
   */
  constructor (time) {
    const hours = Number(time.slice(0, 2))
    this.minuites = Number(time.slice(3, 5)) + hours * 60
  }

  /** 時間の加算
   * @arg {Number} mins - 加算する分
   * @return {Object} 呼び出しインスタンスの参照
   */
  addMinuites (mins) {
    this.minuites += mins
    return this
  }

  /** 時間の減算
   * @arg {Number} mins - 減算する分
   * @return {Object} 呼び出しインスタンスの参照
   */
  decresaseMinuites (mins) {
    this.minuites -= mins
    return this
  }

  /** 文字列表示をする
   * @return {String}
   */
  toString () {
    const hours = Math.floor(this.minuites / 60)
    const mins = Math.floor(this.minuites % 60)
    let formatedHours = ''
    if (hours < 10) { // 1桁のとき、0を補う
      formatedHours = '0' + String(hours)
    } else {
      formatedHours = String(hours)
    }
    let formatedMins = ''
    if (mins < 10) {
      formatedMins = '0' + String(mins)
    } else {
      formatedMins = String(mins)
    }

    return formatedHours + ':' + formatedMins
  }

  /** minuitesのゲッター
   * @return {Number} minuites - 時刻の累計分
   */
  getMinutes () {
    return this.minuites
  }
}



// WEBPACK FOOTER //
// ./src/modules/time.js